/**
 * Formats a number as currency with 2-3 decimal places, removing trailing zeros
 * but ensuring at least 2 decimal places are displayed.
 * 
 * Examples:
 * - 1 → £1.00
 * - 1.25 → £1.25
 * - 1.234 → £1.234
 * - 1.2 → £1.20
 * 
 * @param value - The number to format (can be string or number)
 * @returns Formatted currency string with £ prefix
 */
export const formatCurrencyTwoToThreeDecimals = (value: string | number): string => {
    const num = parseFloat(String(value));
    if (isNaN(num)) return '£0.00';
    
    // Format to 3 decimal places first
    let formatted = num.toFixed(3);
    
    // Remove trailing zeros (but preserve decimal point)
    formatted = formatted.replace(/0+$/, '');
    
    // If we removed all decimal digits, add back 2 decimal places
    // If we have less than 2 decimal places, pad to 2
    if (!formatted.includes('.')) {
        formatted = num.toFixed(2);
    } else {
        const decimalPart = formatted.split('.')[1];
        if (decimalPart.length < 2) {
            formatted = num.toFixed(2);
        }
    }
    
    return '£' + formatted;
};

